export const API_URL = `https://supplier.malmora.com`